import { render } from "./mtzx.vue?vue&type=template&id=64c117b2&scoped=true"
import script from "./mtzx.vue?vue&type=script&lang=js"
export * from "./mtzx.vue?vue&type=script&lang=js"

import "./mtzx.vue?vue&type=style&index=0&id=64c117b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c117b2"]])

export default __exports__